
import css from 'styled-jsx/css';

export default css.global`/* @styled-jsx=global */

.editorial-info__attributes {
  margin-top: -30px;

  b {
    display: block;
    margin-top: 28px;
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    font-family: 'Intercom Brand';
    letter-spacing: 0.6px;
    line-height: 19px;
    text-transform: uppercase;
  }

  p {
    margin-bottom: 0.6em;
    font-size: 16px;
    letter-spacing: 0.01em;
    line-height: 143%;
  }
}

@include media-query(desktop) {
  .editorial-info {
    max-width: 315px;
  }
}
`